import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LightShowService } from '../_services/light-show.service';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject, Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { map, tap, retryWhen, delayWhen } from 'rxjs/operators';
import { NetworkSyncService } from '../_services/network-sync.service';
import { AuthService } from '../_services/auth.service';
import { IAngularMyDpOptions, IMyDate, IMyDateModel } from 'angular-mydatepicker';
import { GetErrorMessage } from '../_shared/utils'

@Component({
  templateUrl: './networksync-modal.component.html',
  styleUrls: ['./networksync-modal.component.css']
})

export class NetworkSyncModalComponent implements OnInit {

  @Output() hasError = new EventEmitter();
  @Output() errorMessage = new EventEmitter();

  @Output() published = new EventEmitter();

  public serviceId;
  public controllerPath;
  public displayCountDown: boolean;

  public networkSyncTimeRemaining = -1;

  private networkSyncCountdown = -1;
  private interval: NodeJS.Timeout;

  public modalState = 0;
  public startCountdownTime = 10;

  private _onDestroy$: Subject<void> = new Subject();
  private networkSyncTimeRemainingSub: Subscription;

  public tabMode = 0;
  public timeZones = [];
  public selectedTimeZone = '0';
  public scheduleTime = '18:00';

  public days = 1;
  public hours = 0;
  public minutes = 0;

  public connectionIssues = false;
  public ellipsis = '';

  public invalidPublishTime = false;

  @ViewChild('start', { read: ElementRef, static: false })
  public startPicker: ElementRef;

  public startDate: IMyDateModel;
  public defaultDate;
  
  public startDateOptions: IAngularMyDpOptions = {
    markCurrentDay: true,
    dateFormat: 'mm/dd/yyyy',
    dateRange: false
  };

  constructor(
    private bsModalRef: BsModalRef,
    private networkSyncService: NetworkSyncService,
    private authService: AuthService
    ) { }

    ngOnInit() {
      this.authService.getAvailableTimeZones()
      .subscribe(data => {
        this.timeZones = data;
        const timeZone = localStorage.getItem('timezone');
        if (timeZone) {
          this.selectedTimeZone = timeZone;
        }
      });

      this.startDateOptions.stylesData = {
        selector: 'start',
        styles: `
          .start .myDpSelectorAbsolute { right: 100px !important; z-index: 100; }
          .myDpSelectorArrowLeft:after, .myDpSelectorArrowLeft:before { visibility: hidden; }
        `
      };

      const dateNow = new Date(Date.now());
      this.startDate = {isRange: false, singleDate: { jsDate: dateNow, formatted: `${dateNow.getMonth() + 1}/${dateNow.getDate()}/${dateNow.getFullYear()}` }}; // set init data

      this.startDateOptions.disableUntil =  this.toMyDate(this.addDays(this.startDate.singleDate.jsDate, -1));


    }

    private addDays(date: Date, days: number): Date {
      const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      result.setDate(result.getDate() + days);
      return result;
    }

    compare(val1, val2) {
      return val1 === val2;
    }

    private toMyDate(date: Date): IMyDate {
      return {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
      };
    }

    validatePublishTime() {
      if (this.days > 29) {
        this.days = 29;
      } else if (this.days < 0) {
        this.days = 0;
      }

      if (this.hours > 23) {
        this.hours = 23;
      } else if (this.hours < 0) {
        this.hours = 0;
      }

      if (this.minutes > 59) {
        this.minutes = 59;
      } else if (this.minutes < 0) {
        this.minutes = 0;
      }

      if (this.days === null || this.hours === null || this.minutes === null  || (this.days === 0 && this.hours === 0 && this.minutes === 0)) {
        this.invalidPublishTime = true;
      } else {
        this.invalidPublishTime = false;
      }


    }

    private getToday(): Date {
      const now = new Date(Date.now());
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }

    public publishMessage() {
      const totalLifetime = this.days * 1440 + this.hours * 60 + this.minutes;

      this.networkSyncService.publishMessage(this.serviceId, totalLifetime).subscribe(
        () => {
          this.published.emit(true);
          this.bsModalRef.hide();
        },
        error => {
          this.hasError.emit(true);
          this.errorMessage.emit(GetErrorMessage(error));
          this.bsModalRef.hide();
        }
      );
    }

    startNetworkSyncModal() {
      this.modalState = 2;

      const aTimer = timer(100, 500);
      aTimer.pipe(takeUntil(this._onDestroy$)).subscribe( _ => {
        this.ellipsis === '...' ? this.ellipsis = '' : this.ellipsis += '.';
      });

      if (this.tabMode === 0) {

        const networkSyncObs = this.networkSyncService
          .startNetworkSync(this.serviceId, this.controllerPath, this.startCountdownTime)
          .pipe(takeUntil(this._onDestroy$));

        let retries = 0;
        const maxRetries = 5;
        const retryPipe = networkSyncObs.pipe(
            map(countdownTime => {
              return Date.now();
            }),
            retryWhen(errors =>
              errors.pipe(
                tap( pipedErrors => {
                  if (++retries >= maxRetries) {
                    throw pipedErrors;
                  }
                  if (retries > 1) {
                    this.connectionIssues = true;
                  }
                }),
                delayWhen(val => timer(3000))
              ))
          );

        this.networkSyncTimeRemainingSub = retryPipe.subscribe(
            countdownTime => {
              this.connectionIssues = false;
              this.networkSyncCountdown = countdownTime;
              this.modalState = 3;
              this.startCountdownTimer();
            },
            error => {
              this.hasError.emit(true);
              this.errorMessage.emit(GetErrorMessage(error));
              this.bsModalRef.hide();
            }
          );

      } else {
        localStorage.setItem('timezone', this.selectedTimeZone);
        this.networkSyncService
        .scheduleNetworkSync(this.serviceId, this.controllerPath, this.selectedTimeZone, this.startDate.singleDate.formatted, this.scheduleTime)
          .pipe(takeUntil(this._onDestroy$))
          .subscribe(
            countdownTime => {
              this.modalState = 4;
              this.bsModalRef.hide();
            },
            error => {
              this.hasError.emit(true);
              this.errorMessage.emit(GetErrorMessage(error));
              this.bsModalRef.hide();
            });
        }

        
      
    }

    private startCountdownTimer() {
      this.interval = setInterval(() => {
        this.networkSyncTimeRemaining = (this.networkSyncCountdown + this.startCountdownTime * 1000) - Date.now();
        if (this.networkSyncTimeRemaining <= 0) {
          this.networkSyncTimeRemaining = 0;
          this.modalState = 4;
          clearInterval(this.interval);
        }
      }, 10);
    }

    public close() {
      if (this.networkSyncTimeRemainingSub) {
        this.networkSyncTimeRemainingSub.unsubscribe();
      }
      this.hasError.emit(false);
      this.bsModalRef.hide();
    }

}
